<template>
    <div class="attention-details-flex flex xl:flex-row xl:flex-no-wrap md:flex-col md:flex-wrap">
        <div class="attention-details-left flex justify-between xl:w-1/2 md:w-full">
            <div class="attention-details-left-top self-end xl:w-w270 xl:mb-0 md:w-full md:pb-4">
                <h2 class="text-white text-size28 tracking-space3 leading-9 font-semibold pb-4">
                    Attention to Detail
                </h2>
                <p class="text-white text-14 leading-spc5">
                    Every element was designed for
                    <br class="xl:block md:hidden">efficiency, endurance and aesthetic.
                </p>
            </div>
            <div class="attention-details-left-bottom">
                <img class="right-0 xl:w-auto md:w-full" src="../../../assets/images/attention-detail2.jpg" alt="Attention Details">
            </div>
        </div>
        <div class="attention-details-right pt-4 xl:pl-4 xl:w-1/2 md:w-full md:pl-0">
            <img class="xl:w-auto md:h-full" src="../../../assets/images/model-x-attention-to-detail.jpg" alt="Model x attention">
        </div>
    </div>
</template>

<script>
    export default {
        name: "ExteriorAttentionDetailTop"
    }
</script>

<style scoped>

</style>